import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_settings_page-brand_sent_emails_bulk_action-click';

/**
 * Click of "(Opt in to)/(Opt out of) all emails from brands via Faire" button on the brand-sent email preferences page.

action is "opt-in" or "opt-out"
 */
export function trackRetailerSettingsPageBrandSentEmailsBulkActionClick(
  action: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { action },
  });
}
